import React from 'react';
import '../../Styles/Dashboard__ChartLegend.scss';

export default function Dashboard__ChartLegend(props) {
    return (
        <div className="chart-legend">
            <div className="chart-legend__col">
                <div className="chart-legend__value">
                    1232
                </div>
                <div className="chart-legend__name">
                    Some Data
                </div>
            </div>

            <div className="chart-legend__col">
                <div className="chart-legend__value">
                    1232
                </div>
                <div className="chart-legend__name">
                    Some Data
                </div>
            </div>
            
            <div className="chart-legend__col">
                <div className="chart-legend__value">
                    1232
                </div>
                <div className="chart-legend__name">
                    Some Data
                </div>
            </div>
        </div>
    )
}